import { ADVANCED_VERTICAL_STEPPER_GROUP_TYPE, ADVANCED_VERTICAL_STEPPER_STAGE, ADVANCED_VERTICAL_STEPPER_STATUS, ADVANCED_VERTICAL_STEPPER_TYPE } from '../types.js';
export const getVerticalStepperItems = (items) => {
    let stage;
    return items.reduce((previousStorage, currentItem, index) => {
        const previousItem = previousStorage.pop();
        stage =
            index === 0
                ? ADVANCED_VERTICAL_STEPPER_STAGE.FIRST_STAGE
                : index === items.length - 1
                    ? ADVANCED_VERTICAL_STEPPER_STAGE.LAST_STAGE
                    : ADVANCED_VERTICAL_STEPPER_STAGE.INTERMEDIATE_STAGE;
        if (previousItem?.headerLabel && currentItem.groupType === ADVANCED_VERTICAL_STEPPER_GROUP_TYPE.GROUP_ITEM) {
            previousStorage.push(previousItem);
            return previousStorage.concat({
                ...currentItem,
                stage
            });
        }
        if (previousItem?.groupType === ADVANCED_VERTICAL_STEPPER_GROUP_TYPE.GROUP_ITEM &&
            currentItem.groupType === ADVANCED_VERTICAL_STEPPER_GROUP_TYPE.GROUP_ITEM) {
            previousStorage.push(previousItem);
            return previousStorage.concat({
                ...currentItem,
                stage
            });
        }
        if (previousItem?.groupType === ADVANCED_VERTICAL_STEPPER_GROUP_TYPE.GROUP_ITEM &&
            (!currentItem || !currentItem?.groupType)) {
            previousStorage.push({ ...previousItem, isNextUngroupedItem: true });
            return previousStorage.concat({
                ...currentItem,
                stage
            });
        }
        if (previousItem) {
            previousStorage.push(previousItem);
        }
        return previousStorage.concat({
            ...currentItem,
            stage
        });
    }, []);
};
export const getConnectorBackgroundColor = (args) => {
    const { status, currentPosition, position } = args;
    if (currentPosition === position) {
        return 'twds-bg-blue-600 dark:twds-bg-blue-500';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE) {
        return 'twds-bg-teal-500 dark:twds-bg-teal-500';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return 'twds-bg-red-500 dark:twds-bg-red-500';
    }
    return null;
};
export const getConnectorBorderColor = (args) => {
    const { status, currentPosition, position, maxStatusFilledIndex } = args;
    if (currentPosition === position) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE) {
        return 'twds-border-teal-500';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return 'twds-border-red-500';
    }
    if (currentPosition > position || (typeof maxStatusFilledIndex === 'number' && maxStatusFilledIndex > position)) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (currentPosition < position) {
        return 'twds-border-gray-300 dark:twds-border-gray-900';
    }
    return null;
};
export const getTopConnectorBorderColor = (args) => {
    const { currentPosition, position, status, maxStatusFilledIndex } = args;
    if (currentPosition === position) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (status) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (currentPosition > position || (typeof maxStatusFilledIndex === 'number' && maxStatusFilledIndex > position)) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (currentPosition < position) {
        return 'twds-border-gray-300 dark:twds-border-gray-900';
    }
    return null;
};
export const getBottomConnectorBorderColor = (args) => {
    const { currentPosition, position, nextItemStatus, status, maxStatusFilledIndex } = args;
    if (nextItemStatus || (currentPosition > position && !nextItemStatus && status)) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (currentPosition > position || (typeof maxStatusFilledIndex === 'number' && maxStatusFilledIndex > position)) {
        return 'twds-border-blue-600 dark:twds-border-blue-500';
    }
    if (currentPosition <= position) {
        return 'twds-border-gray-300 dark:twds-border-gray-900';
    }
    return null;
};
export const getContentIconBackgroundColor = (args) => {
    const { status, currentPosition, position } = args;
    if (currentPosition === position) {
        return 'twds-bg-blue-500 dark:twds-bg-blue-600';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return 'twds-bg-red-500 dark:twds-bg-red-600';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE) {
        return 'twds-bg-blue-150 dark:twds-bg-blue-800';
    }
    return 'twds-bg-gray-200 dark:twds-bg-gray-900';
};
export const getContentIconTextColor = (args) => {
    const { status, currentPosition, position, isPreviousNonOptionalItemFilled, optional, stepperType } = args;
    if (currentPosition === position) {
        return 'twds-text-[#ffffff] dark:twds-text-[#ffffff]';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return 'twds-text-[#ffffff] dark:twds-text-[#ffffff]';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE ||
        isPreviousNonOptionalItemFilled ||
        optional ||
        position === 0 ||
        stepperType === ADVANCED_VERTICAL_STEPPER_TYPE.NON_CONSECUTIVE) {
        return 'twds-text-gray-700 dark:twds-text-gray-400';
    }
    return 'twds-text-gray-400 dark:twds-text-gray-600';
};
export const getContentBackgroundColor = (args) => {
    const { status, currentPosition, position, isPreviousNonOptionalItemFilled, optional, stepperType } = args;
    if (currentPosition === position) {
        return 'twds-bg-[#CFE8FC80] dark:twds-bg-[#00153380] twds-bg-opacity-50 dark:twds-bg-opacity-50';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return 'twds-bg-[#FCD4D480] dark:twds-bg-[#320606] twds-bg-opacity-50 dark:twds-bg-opacity-50';
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE ||
        isPreviousNonOptionalItemFilled ||
        optional ||
        position === 0 ||
        stepperType === ADVANCED_VERTICAL_STEPPER_TYPE.NON_CONSECUTIVE) {
        return null;
    }
    return 'twds-bg-[#000000] dark:twds-bg-[#ffffff] twds-bg-opacity-[0.04] dark:twds-bg-opacity-[0.04]';
};
export const getContentBorderColor = (args) => {
    const { status, currentPosition, position, isPreviousNonOptionalItemFilled, optional, stepperType } = args;
    const defaultStyle = 'hover:twds-border-gray-800 dark:hover:twds-border-gray-600';
    if (currentPosition === position) {
        return `${defaultStyle} twds-border-blue-600 dark:twds-border-blue-500`;
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.ERROR) {
        return `${defaultStyle} twds-border-red-500 dark:twds-border-red-500`;
    }
    if (status === ADVANCED_VERTICAL_STEPPER_STATUS.COMPLETE ||
        isPreviousNonOptionalItemFilled ||
        optional ||
        position === 0 ||
        stepperType === ADVANCED_VERTICAL_STEPPER_TYPE.NON_CONSECUTIVE) {
        return defaultStyle;
    }
    return 'twds-border-gray-300 dark:twds-border-gray-500/30';
};
export const findMaxStatusFillIndex = (items) => {
    let maxIndex = -1;
    for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].status) {
            maxIndex = i;
            break;
        }
    }
    return maxIndex;
};
export const findPreviousFilledStatus = (items, position) => {
    let prevIndex = position - 1;
    while (prevIndex >= 0) {
        const prevItem = items[prevIndex];
        if (prevItem?.optional) {
            prevIndex--;
        }
        else if (prevItem?.status) {
            return true;
        }
        else if (!prevItem?.status) {
            return false;
        }
    }
    return false;
};
//# sourceMappingURL=advanced_vertical_stepper.logic.js.map